/**
 * Compute the concrete money discount for an affiliate code, given the raw
 * `discount_type` + `discount_value` from `/api/affiliate/validate/{code}`
 * and the cart subtotal.
 *
 * The `/api/affiliate/validate` endpoint returns only raw fields (unlike
 * `/api/promo/validate` which pre-computes `discount_amount`), so any UI
 * that consumes affiliate responses must derive the money value here.
 *
 * @param {Object} data      Response body from /api/affiliate/validate
 * @param {number} subtotal  Cart subtotal in DA
 * @returns {number}         Rounded discount amount in DA (0 if unapplicable)
 */
export function computeAffiliateDiscount(data, subtotal) {
  if (!data) return 0;
  const value = Number(data.discount_value || 0);
  const total = Number(subtotal || 0);
  if (!value || !total) return 0;
  let discount = 0;
  if (data.discount_type === 'percentage') {
    discount = total * (value / 100);
  } else {
    discount = Math.min(value, total);
  }
  return Math.max(0, Math.round(discount));
}
